import { IsString, IsOptional } from 'class-validator';

export class NomenclaturePositionChildOptionsUpdateRequest {
    @IsString()
    public nomPositionUuid: string;

    @IsOptional()
    @IsString()
    public condition?: string;

    constructor(data?: Partial<NomenclaturePositionChildOptionsUpdateRequest>) {
        this.nomPositionUuid = data?.nomPositionUuid;
        this.condition = data?.condition;
    }

    /**
     * Options may be sent as a string, an array of strings, or an array of objects.
     * So, we should handle all of the cases
     */
    public static from(data: string | string[] | Partial<NomenclaturePositionChildOptionsUpdateRequest>[]): NomenclaturePositionChildOptionsUpdateRequest[] {
        if (typeof data === 'string') {
            return [new NomenclaturePositionChildOptionsUpdateRequest({ nomPositionUuid: data })];
        }

        if (Array.isArray(data)) {
            return data.map(item => new NomenclaturePositionChildOptionsUpdateRequest(
                typeof item === 'string' ? { nomPositionUuid: item } : item
            ));
        }

        return data;
    }
}
